// Genomics Research lab Panel GenomicsResearchLab
import { Route, Switch, useRouteMatch } from "react-router-dom";
import GenomicsResearchlabDash from "./index";
import { useUser } from "../../providers/user";
import GenLabBilling from "./Components/Bookings/billing";
import GenLabLabraryCreate from "./Components/Bookings/createLibrary";
import GenCloserForm from "./Components/Bookings/DownloadBooking/closerForm";
import GenLabProjectCloserForm from "./Components/Bookings/DownloadBooking/Tablemy";
import GenLabFinalreportView from "./Components/Bookings/ViewBooking/index";
import GenLabLabraryExport from "./Components/LibraryExport/index";
import GenLabSampleExport from "./Components/SampleExport/index";
import GenLabSampleStorageExport from "./Components/SampleStorageExport/index";
import GenLabSequencingTable from "./Components/SequencingExport/index";
import GenLabBillingView from "./Components/ViewBillings/index";
import GenLabFilter from "./Pages/filter";
import GenLabHome from "./Pages/Home/home";
import GenLabBillings from "./Tables/Billings/BillingFilterData";
import GenLabOnboardCloseProject from "./Tables/Billings/onboardCloseProject";
import GenLabBioInformation from "./Tables/BioInformatics/index";
import GenLabDataQc from "./Tables/DataQC/dataQcFilterTable";
import GenLabNewQc from "./Tables/DataQC/newQcData";
import GenLabFinalReport from "./Tables/DeliverableSection/index";
import GenLabLabrary from "./Tables/Library/index";
import GenLabRunPlan from "./Tables/runPlanValidate";
import GenLabSampleQC from "./Tables/SampleQC/index";
import SampleRegister from "./Tables/SampleRegister/index";
import GenLabSampleStorage from "./Tables/SampleStorage/index";
import GenLabSequencing from "./Tables/Sequencing/index";

function GenomicsResearchLabRoutes() {
  const { path } = useRouteMatch();
  const user = useUser();

  return (
    <Switch>
      <GenomicsResearchlabDash>
        <Route
          exact
          path={`${path}`}
          component={GenLabHome}
        />
        <Route
          exact
          path={`${path}/sample/storage`}
          component={GenLabSampleStorage}
        />
        <Route
          exact
          path={`${path}/sample/qc`}
          component={GenLabSampleQC}
        />
        <Route
          exact
          path={`${path}/library`}
          component={GenLabLabrary}
        />
        <Route
          exact
          path={`${path}/library/create`}
          component={GenLabLabraryCreate}
        />
        <Route
          exact
          path={`${path}/projectCloser/form/:id`}
          component={GenLabProjectCloserForm}
        />
         <Route
          exact
          path={`${path}/projectCloser/form1/:id`}
          component={GenCloserForm}
        />
        <Route
          path={`${path}/project-samples`}
          component={SampleRegister}
        />
        <Route
          path={`${path}/sample_export`}
          exact
          component={GenLabSampleExport}
        />
        <Route
          path={`${path}/labrary_export`}
          exact
          component={GenLabLabraryExport}
        />
        <Route
          path={`${path}/sample/stoarge_export`}
          exact
          component={GenLabSampleStorageExport}
        />
        
        <Route
          path={`${path}/Sequencing`}
          exact
          component={GenLabSequencing}
        />
        <Route
          path={`${path}/runvalidation`}
          exact
          component={GenLabRunPlan}
        />
        <Route
          path={`${path}/Sequencing/export`}
          exact
          component={GenLabSequencingTable}
        />
        <Route
          path={`${path}/Project/data`}
          exact
          component={GenLabFilter}
        />
        <Route
          path={`${path}/dataqc`}
          exact
          component={GenLabDataQc}
        />
        <Route
          path={`${path}/dataqc/new/:id`}
          exact
          component={GenLabNewQc}
        />
        {user.hasPermission("gr:bioinformatics") &&<Route
          path={`${path}/bioinform`}
          exact
          component={GenLabBioInformation}
        />}
        {user.hasPermission("gr:deliverables") && <>
        <Route
          path={`${path}/final_reports`}
          exact
          component={GenLabFinalReport}
        />
        <Route
          path={`${path}/view/final_report`}
          exact
          component={GenLabFinalreportView}
        /></>}
        {user.hasPermission("gr:billing") && 
        <>
        <Route
          path={`${path}/billing`}
          exact
          component={GenLabBilling}
        />
        <Route
          path={`${path}/view_billings`}
          exact
          component={GenLabBillingView}
        />
        <Route
          path={`${path}/ProjectCloser`}
          exact
          component={GenLabBillings}
        />
        <Route
          path={`${path}/ProjectCloser/new/:id`}
          exact
          component={GenLabOnboardCloseProject}
        /></>}  
      </GenomicsResearchlabDash>
    </Switch>
  )
}

export default GenomicsResearchLabRoutes;